import { CALL_API } from '../middleware/api';

// ACTIONS

export const TARIFF_FETCH_REQUEST = 'tariff/TARIFF_FETCH_REQUEST';
export const TARIFF_FETCH_SUCCESS = 'tariff/TARIFF_FETCH_SUCCESS';
export const TARIFF_FETCH_ERROR = 'tariff/TARIFF_FETCH_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case TARIFF_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case TARIFF_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        current: action.payload,
      };

    case TARIFF_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Operations

export function fetchTariff(businessId) {
  return {
    [CALL_API]: {
      types: [TARIFF_FETCH_REQUEST, TARIFF_FETCH_SUCCESS, TARIFF_FETCH_ERROR],
      promise: (httpClient) =>
        httpClient.get(`/master/${businessId}/tariff/list`),
    },
  };
}
